export const IMAGE_FORMAT = {
  PNG: "png",
  JPEG: "jpeg",
  JPG: "jpg",
  SVG: "svg",
};
